import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Button, type ButtonProps } from 'src/component/ds/ui/button';

export interface PillProps extends Omit<ButtonProps, 'children' | 'value'> {
  label: string;
  value: React.ReactNode;
  testId?: string;
}


export function Pill ({ label, value, testId, variant = 'secondary', size = 'xs', ...props }: PillProps) {
  return (
    <Button variant={variant} size={size} data-testid={testId} {...props}>
      <span>
        {label}: <span className='ds-font-bold'>{value}</span>
      </span>
      <ChevronRightIcon fontSize='inherit' aria-hidden='true' />
    </Button>
  );
}
